import React, { useEffect } from 'react';
import './SiteMap.scss';

import { Link } from 'react-router-dom';


function Accesibility() {
  useEffect(() => { document.title = 'Plan du site — BAsique'; }, []);
  return (
    <div className="siteMap page-transition">
        <div className='siteMap__div'>
            <div className='siteMap-content__div'>
                <Link to="/" className='LinkNoStyle'><h1 className='siteMap__h1'>Accueil :</h1></Link>
                <p className='siteMap__p'>Page principale présentant une vue d'ensemble de notre épicerie bio en vrac à Roanne.</p>
            </div>
            <div className='siteMap-content__div'>
                <h1 className='siteMap__h1'>Contact :</h1>
                <p className='siteMap__p'>Retrouvez tous les moyens pour nos contacter (adresse, téléphone, e-mail, réseaux sociaux) directement
                en haut de votre page, dans l'en-tête du site.</p>
            </div>
            <div className='siteMap-content__div'>
                <Link to="/accessibility" className='LinkNoStyle'><h1 className='siteMap__h1'>Accessibilité :</h1></Link>
                <p className='siteMap__p'>Page décrivant notre politique d'accessibilité, notre engagement et les moyens de nous contacter 
                pour des demandes spécifiques</p>
            </div>
            <div className='siteMap-content__div'>
                <Link to="/confidentiality" className='LinkNoStyle'><h1 className='siteMap__h1'>Vos données :</h1></Link>
                <p className='siteMap__p'>Page décrivant notre politique de confidentialité.</p>
            </div>
        </div>
    </div>
  );
};

export default Accesibility;